import {
	type MarketResponseDto,
	OrderTimelineKeyEnum,
} from "Infrastructure/Api/Api";
import { Resources, useResource } from "Infrastructure/Translation/Resources";
import { formatCurrency } from "Infrastructure/Utilities/currencyFormat";
import { useMarket } from "Market/Providers/CurrentMarketProvider";
import { usePartnersListQuery } from "Partner/Api/Query/usePartnersListQuery";

const orderResources = Resources.base.order.selectOptions;

export const useFormatTimelineValues = (market: MarketResponseDto) => {
	const { t } = useResource();
	const currentMarketId = useMarket()?.market?.id;
	const { data: partners } = usePartnersListQuery({
		marketId: currentMarketId,
	});

	const formatValue = (
		key: OrderTimelineKeyEnum,
		value?: string | number | null,
	) => {
		if (!value) {
			return "-";
		}

		if (key === OrderTimelineKeyEnum.status) {
			return t(orderResources.orderStatus[value]);
		}

		if (key === OrderTimelineKeyEnum.partnerId) {
			const partner = partners?.data?.find(
				({ partner }) => partner.id === Number(value),
			)?.partner;
			const partnerName = partner
				? `${partner.surname} ${partner.name} ${partner.middleName}`
				: "";
			return partnerName;
		}

		if (key === OrderTimelineKeyEnum.price) {
			return formatCurrency(market.country, market.currency, Number(value));
		}

		return value;
	};

	return formatValue;
};
